'use strict';
import formActivityFeedTemplate from './ngTemplates/project-form-requirements-activity-feed.html';
import requirementsFormTemplate from './ngTemplates/project-requirements-form-details.html';
import {projectRequirementCtrlConfig} from './router-project-file-requirements';
import {projectFormRequirementStates} from './router-config';


routerProjectsFormRequirementsProvider.$inject = [
  '$stateProvider',
];

export function routerProjectsFormRequirementsProvider($stateProvider) {
  $stateProvider
    .state(projectFormRequirementStates.details, {
      title: 'requirements.views.form.title',
      url: '/tasks/requirements/:requirementId/form',
      views: {
        'tab-projects-tasks': {
          template: requirementsFormTemplate,
        },
      },
      resolve: {
        ctrlConfig: () => projectRequirementCtrlConfig,
      },
    })

    .state(projectFormRequirementStates.activityFeed, {
      title: 'requirements.views.activity.title',
      url: '/tasks/requirements/:requirementId/form-activity-feed',
      views: {
        'tab-projects-tasks': {
          template: formActivityFeedTemplate,
        },
      },
      resolve: {
        ctrlConfig: () => projectRequirementCtrlConfig,
      },
    });
}



// WEBPACK FOOTER //
// ./src/js/requirements/router-project-form-requirements.js